import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays the full-width product discount bar.
 * Mirrors product-price.js: it listens for variant update events on the closest
 * section and swaps its own content with the re-rendered bar from the new HTML,
 * so the discount percentage follows the selected variant.
 */
class SphDiscountBar extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /**
   * Updates the bar from the re-rendered section HTML.
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  update = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const next = html.querySelector('sph-discount-bar');
    if (next && this.innerHTML !== next.innerHTML) {
      this.innerHTML = next.innerHTML;
    }
  };
}

if (!customElements.get('sph-discount-bar')) {
  customElements.define('sph-discount-bar', SphDiscountBar);
}
